import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  ADMIN_CONTACT_PARTNER,
  ADMIN_CONTACT_PARTNER_ROLES_OPTIONS
} from '../../../constants/admin.contacts.constants';
import { currentUserSelector } from '../../../selectors/auth.selectors';
import SelectField from '../../forms/SelectField';
import TextField from '../../forms/TextField';
import { INPUT_STATES } from '../../forms/forms.utils';

const AdminContactPartnerFields = ({ type, data, organizationsDependency, isSubmitting, onInput, parentElement }) => {
  const currentUser = useSelector(currentUserSelector);
  const isCurrentUserPartner = currentUser?.type === ADMIN_CONTACT_PARTNER;
  const currentUserOrganization = currentUser?.permissionsWithTreepaths?.[0]?.treePath;

  useEffect(() => {
    if (isCurrentUserPartner && !organizationsDependency.isLoading && organizationsDependency.isLoaded) {
      if (organizationsDependency.options?.find((opt) => opt.value === currentUserOrganization)) {
        onInput(currentUserOrganization, 'organization');
      }
    }
  }, [
    onInput,
    isCurrentUserPartner,
    organizationsDependency.options,
    organizationsDependency.isLoaded,
    organizationsDependency.isLoading,
    currentUserOrganization
  ]);

  if (type !== ADMIN_CONTACT_PARTNER) {
    return null;
  }

  return (
    <>
      <SelectField
        id="add-contact-modal-oganization"
        label="Organisatie"
        name={'organization'}
        className="u-margin-bottom"
        required
        onChange={(value) => onInput(value, 'organization')}
        disableSearch={true}
        options={organizationsDependency.options}
        value={data?.organization}
        isSubmitting={organizationsDependency.isLoading}
        hasError={!!organizationsDependency.loadError}
        description={organizationsDependency.loadError}
        disabled={isCurrentUserPartner || isSubmitting}
        parentElement={parentElement}
      />
      <TextField
        label="Functie"
        name={'function'}
        value={data.function}
        state={INPUT_STATES.DEFAULT}
        className="u-margin-top"
        // onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'function')}
        disabled={isSubmitting}
      />
      <SelectField
        id="add-contact-modal-role"
        label="Rechten"
        name={'role'}
        onChange={(value) => onInput(value, 'role')}
        disableSearch={true}
        options={ADMIN_CONTACT_PARTNER_ROLES_OPTIONS}
        parentElement={parentElement}
        value={data.role}
        className="u-margin-top"
        disabled={isSubmitting}
      />
    </>
  );
};

export default AdminContactPartnerFields;
